import { useRef } from "react";
import Inquiry from "./Inquiry";
import ModalPop from "./ModalPop";

const Contact = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div
      id="contact"
      className="relative w-full h-full mx-auto pb-14 lg:pb-28 xl:pb-36 text-white"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className=" relative w-full h-fit py-7 lg:py-14">
        <img
          src="/images/contactTitle.png"
          alt="누수 상담 문의 안내"
          className="absolute left-0 top-0 w-full h-full"
        />
        <div className="relative w-fit h-full text-center mx-auto">
          <p className="text-xl lg:text-3xl leading-snug">
            정확한&nbsp;정보가&nbsp;없어
            답답할때&nbsp;고민만&nbsp;계속&nbsp;하고&nbsp;계신다면?
          </p>

          <h2 className="gbold mt-3 lg:mt-6 text-[37px] font-black leading-[1.08] tracking-[-0.08em] sm:text-[40px] lg:text-[62px]">
            이젠 누수도 스마트하게
            <br />
            <span className="text-point">스마트 장인누수와 함께</span>{" "}
            해결해보세요
          </h2>

          <p className="mt-7 text-xl lg:text-3xl leading-snug tracking-[-0.08em]">
            365일 24시간 언제든지 문의 가능하며
            <br />
            카톡&nbsp;·&nbsp;전화&nbsp;·&nbsp;문자
            어떤&nbsp;방식으로도&nbsp;상담이&nbsp;가능합니다
          </p>
        </div>
      </div>
      <div className="my-8 lg:my-12 px-2 lg:px-0">
        <div className="relative w-full max-w-screen-md mx-auto h-fit grid grid-cols-2 mt-5 gap-2 lg:gap-5 lg:mt-10">
          <button
            type="button"
            onClick={() => (window.location.href = "tel:010-8912-1202")}
            className={`rounded-2xl bg-secondary lg:px-8 py-1 lg:pt-2 text-xl text-white shadow-md transition hover:brightness-110 active:scale-[0.98]`}
          >
            <h4 className="text-white font-light lg:text-2xl 2xl:text-3xl">
              상담신청
            </h4>
          </button>
          <button
            type="button"
            onClick={openfunc}
            className={`rounded-2xl bg-white border-2 border-red lg:px-8 py-1 lg:pt-2 text-xl text-white shadow-md transition hover:brightness-110 active:scale-[0.98]`}
          >
            <h4 className="text-red font-light lg:text-2xl 2xl:text-3xl">
              긴급출동
            </h4>
          </button>
        </div>
        <div
          data-aos="fade-up"
          className="relative w-fit h-fit lg:max-w-96 3xl:max-w-none mx-auto mt-6 lg:mt-10"
        >
          <img
            onClick={() => {
              window.location.href = "tel:010-8912-1202";
            }}
            alt="스마트장인누수 로고"
            className="!relative w-full h-auto mb-5 max-w-64 mx-auto object-contain cursor-pointer"
            src="/images/logo.png"
            width={341}
            height={113}
          />
          <img
            onClick={() => {
              window.location.href = "tel:010-8912-1202";
            }}
            className="!relative w-full h-full max-h-14 3xl:max-h-16 object-contain cursor-pointer"
            alt="전화 상담 010-8912-1202"
            src={"images/num.png"}
            width={532}
            height={132}
          />
        </div>
      </div>
      <div className="relative w-full h-fit px-[calc((100%-var(--container))/2)] max-w-[1600px] mx-auto ">
        <Inquiry />
      </div>
    </div>
  );
};

export default Contact;
